import { ArrowRight, Check } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Eyebrow, FadeIn } from "./primitives";
import { steps } from "@/data/dashboard";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { toast } from "@/components/ui/sonner";
import { cn } from "@/lib/utils";
import { DASHBOARD } from "@/constants/testIds";

const StepDot = ({ n, done, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={`Step ${n}`}
    className="flex items-center justify-center focus-visible:outline-none"
  >
    <span
      className={cn(
        "flex h-9 w-9 items-center justify-center rounded-full border text-[12px] font-medium tabular-nums transition-colors",
        done
          ? "border-primary/50 bg-primary/15 text-primary"
          : "border-border text-muted-foreground hover:border-border-strong hover:text-foreground",
      )}
    >
      {done ? <Check className="h-4 w-4" /> : n}
    </span>
  </button>
);

export const StepWork = () => {
  const [done, setDone] = useLocalStorage("ts.steps", []);
  const toggle = (n) =>
    setDone((prev) =>
      prev.includes(n) ? prev.filter((x) => x !== n) : [...prev, n].sort((a, b) => a - b),
    );

  return (
    <FadeIn>
      <Card className="p-6 shadow-soft sm:p-7">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <Eyebrow>Step Work</Eyebrow>
            <h3 className="mt-2 font-display text-2xl font-medium tracking-tightish text-foreground">
              Start wherever you are.
            </h3>
          </div>
          <Button
            className="rounded-full"
            onClick={() => toast("The Twelve Steps", { description: "This is a design prototype." })}
            data-testid={DASHBOARD.seeSteps}
          >
            See the steps <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
        <div className="mt-7 grid grid-cols-6 gap-2.5 sm:grid-cols-12">
          {steps.map((n) => (
            <StepDot key={n} n={n} done={done.includes(n)} onClick={() => toggle(n)} />
          ))}
        </div>
        <p className="mt-5 text-[13px] text-muted-foreground">
          {done.length} of 12 worked — tap a number to mark your progress.
        </p>
      </Card>
    </FadeIn>
  );
};
